// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".not_selected_dropdown{background-color:#fdfdec!important}.tooltip .tooltip-inner{margin:10px 10px 0 10px;max-width:500px!important;text-align:left}", ""]);
// Exports
module.exports = exports;
